import { 
    IonRouterLink,
    IonAvatar,
    IonCard,
    IonCardHeader,
    IonCardSubtitle,
    IonCardContent,
    IonCardTitle,
    IonButtons,
    IonBackButton,
    IonContent, 
    IonInput, 
    IonButton, 
    IonItem, 
    IonHeader,   
    IonPage, 
    IonTitle, 
    IonToolbar,
    IonGrid,
    IonRow,
    IonCol,
    IonLabel,
    IonIcon,
    NavContext,
    useIonViewWillEnter,
    IonText,
    IonRefresher,
    IonRefresherContent,
    IonAlert,
    IonList,
    useIonRouter
} from '@ionic/react';
import { listOutline, fingerPrintOutline, bodyOutline, walletOutline, exitOutline, keypadOutline, qrCodeOutline, chevronForwardOutline, languageOutline, informationCircleOutline, logOutOutline, key, lockClosedOutline, mail, peopleCircleOutline, personOutline, cameraOutline, logoWebComponent } from "ionicons/icons";
import React, { useState } from "react";
import { LANGUAGE, GetStr } from "../language/Language";
import Vault from '../components/Vault';
import { showAlert } from '../components/Alert';

import NServer, { UIElement } from "../components/NServer";
import { showTab, updateTab } from "../components/Tabs";

import './Main.css';  

const Settings : React.FC = () => {

    const [email, setEmail] = useState("");
    const [name, setName] = useState("User");
    const [avatar, setAvatar] = useState("https://nwallet.site/img/avt.jpg");
    const [askLogout, setAskLogout] = useState(false);

    //	Initializing our router
	const router = useIonRouter();

    useIonViewWillEnter(() => {
        getUserInfo();
        showTab();
    });
    
    // retrieve the user info
    const getUserInfo = async () => {
        
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key
        };

        var server = new NServer();
        await server.sendForm("user_info", state);

        if (server.success)
        {
            let d = server.data;

            // set data
            setEmail(d.email);
            setAvatar(d.avatar);
            setName(d.name);
        }

        updateTab();
    }

    //	go to register page
    const reload = () => {
        router.push("/login", "back", "pop");
    }

    const handleLogout = async () => {
        let v = new Vault();
        await v.read();

        v.account.id = -1;
        v.account.key = "";

        await v.write();

        reload();
    }

    // refresh event
    const doRefresh = async (ev : any) => {
        await getUserInfo();
        ev.detail.complete();
    };

    return (
            <IonPage>
                <IonContent fullscreen>
                    <IonAlert
                        isOpen={askLogout}
                        onDidDismiss={() => setAskLogout(false)}
                        message={ GetStr(LANGUAGE.TXT_ASK_LOGOUT) }
                        buttons={[
                            {
                                text: GetStr(LANGUAGE.TXT_CANCEL),
                                role: 'cancel',
                                cssClass: 'secondary',
                                id: 'cancel-button'
                            },
                            {
                                text: GetStr(LANGUAGE.TXT_OK),
                                id: 'confirm-button',
                                handler: ()=> { handleLogout(); }
                            }
                        ]}
                    />
                    <IonToolbar color="none">
                        <IonButtons slot="start">
                            <IonBackButton text="" defaultHref="/user/me" ></IonBackButton>
                        </IonButtons>
                        <IonTitle><h5>{ GetStr(LANGUAGE.TXT_PROFILE_EDIT) }</h5></IonTitle>
                    </IonToolbar>

                    <IonRefresher  slot="fixed" onIonRefresh={doRefresh}>
                        <IonRefresherContent></IonRefresherContent>
                    </IonRefresher>
                    <IonGrid className="ion-no-padding main-content">
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol size-md="8" size-lg="6" size-xl="4" size="12">
                            <IonRouterLink routerLink="/imgcrop/avt/a/settings/1/1" routerDirection="forward">
                                <IonAvatar className="main-avatar ion-margin-top">
                                    <img src={avatar} onError={ ({currentTarget}) => { currentTarget.src = 'assets/img/avt.jpg' } } />
                                </IonAvatar>
                            </IonRouterLink>
                            <IonCard className="ion-text-center margin-n25 flat-card">
                                <IonCardHeader className="margin-25">
                                    <IonCardTitle><h1><b>{name}</b></h1></IonCardTitle>
                                    <IonCardSubtitle>{ GetStr(LANGUAGE.TXT_EMAIL_DOT) } [{email}]</IonCardSubtitle>
                                </IonCardHeader>
                            </IonCard>
                            <IonCard className="flat-card">
                                <IonList>
                                    <IonItem routerLink="/change-username" lines="none">
                                        <IonIcon icon={personOutline} slot="start" />
                                        <IonLabel>{ GetStr(LANGUAGE.TXT_USERNAME_EDIT) }</IonLabel>
                                        <IonIcon icon={chevronForwardOutline} slot="end" />
                                    </IonItem>
                                    <IonItem routerLink="/imgcrop/avt/a/settings/1/1" lines="none">
                                        <IonIcon icon={cameraOutline} slot="start" />
                                        <IonLabel>{ GetStr(LANGUAGE.TXT_PROFILEPIC_UPLOAD) }</IonLabel>
                                        <IonIcon icon={chevronForwardOutline} slot="end" />
                                    </IonItem>
                                    <IonItem routerLink="/changelang" lines="none">
                                        <IonIcon icon={languageOutline} slot="start" />
                                        <IonLabel>{ GetStr(LANGUAGE.TXT_LANGUAGE_EDIT) }</IonLabel>
                                        <IonIcon icon={chevronForwardOutline} slot="end" />
                                    </IonItem>
                                    <IonItem routerLink="/blocklist" lines="none">
                                        <IonIcon icon={listOutline} slot="start" />
                                        <IonLabel>{ GetStr(LANGUAGE.TXT_BLOCK_LIST) }</IonLabel>
                                        <IonIcon icon={chevronForwardOutline} slot="end" />
                                    </IonItem>
                                    <IonItem onClick={(e) => { setAskLogout(true); } } lines="none">
                                        <IonIcon icon={logOutOutline} slot="start" />
                                        <IonLabel>{ GetStr(LANGUAGE.TXT_LOGOUT) }</IonLabel>
                                        <IonIcon icon={chevronForwardOutline} slot="end" />
                                    </IonItem>
                                </IonList>
                            </IonCard>
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                </IonGrid>
                </IonContent>
            </IonPage>
    );
}

export default Settings;